import React, { FC, useState } from "react";
import styled from "styled-components";
import { CaretIconSvg } from "../../icons/CaretIconSvg";
import { AccordionProps } from "../common/types";

const LabelWrapper = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.color.text};
  font-size: 14px;
`;

const ListWrapper = styled.ul`
  font-size: 13px;
  padding-left: 14px;
  margin-bottom: 0;
  margin-block-start: 5px;
`;

export const Accordion: FC<AccordionProps> = ({ title, list }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <LabelWrapper
        data-testid="accordion"
        onClick={() => {
          setOpen(!open);
        }}
      >
        {title} &nbsp;
        <span>
          <CaretIconSvg upsideDown={open} />
        </span>
      </LabelWrapper>
      {open && (
        <ListWrapper>
          {list.map((item, i) => {
            return <li key={i}>{item}</li>;
          })}
        </ListWrapper>
      )}
    </div>
  );
};
